import React from 'react';
import { Tooltip } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleInfo } from '@fortawesome/free-solid-svg-icons';
import { ContentCard, StyledTabs, StatsRow, StatCard, StatLabel, StatValue, StatHelp, InfoIconButton } from './styles';

const INACCURATE_RATE_TOOLTIP =
  'Percentage of completed orders that were deemed to be inaccurate after review. Excludes orders with fraudulent claims.';
const UNFULFILLED_RATE_TOOLTIP =
  'Percentage of all orders cancelled by you, whether you did so deliberately or did not confirm an order on time.';
const SALES_LOST_TOOLTIP =
  "The subtotal amount of all Unfulfilled orders. This amount does not account for potential taxes and fees.";

const OrdersWithIssuesSection: React.FC = () => (
  <ContentCard>
    <StyledTabs
      defaultActiveKey="inaccurate"
      items={[
        {
          key: 'inaccurate',
          label: 'Inaccurate orders',
          children: (
            <StatsRow>
              <StatCard>
                <StatLabel>
                  Inaccurate order rate
                  <Tooltip title={INACCURATE_RATE_TOOLTIP}>
                    <InfoIconButton type="button" aria-label="Info about Inaccurate order rate">
                      <FontAwesomeIcon icon={faCircleInfo} />
                    </InfoIconButton>
                  </Tooltip>
                </StatLabel>
                <StatValue>0%</StatValue>
              </StatCard>
              <StatCard>
                <StatLabel>Cost of refunds</StatLabel>
                <StatValue>(US$0.00)</StatValue>
              </StatCard>
            </StatsRow>
          ),
        },
        {
          key: 'unfulfilled',
          label: 'Unfulfilled orders',
          children: (
            <StatsRow>
              <StatCard>
                <StatLabel>
                  Unfulfilled order rate
                  <Tooltip title={UNFULFILLED_RATE_TOOLTIP}>
                    <InfoIconButton type="button" aria-label="Info about Unfulfilled order rate">
                      <FontAwesomeIcon icon={faCircleInfo} />
                    </InfoIconButton>
                  </Tooltip>
                </StatLabel>
                <StatValue>0%</StatValue>
                <StatHelp>↑ 23.36%</StatHelp>
              </StatCard>
              <StatCard>
                <StatLabel>
                  Sales lost
                  <Tooltip title={SALES_LOST_TOOLTIP}>
                    <InfoIconButton type="button" aria-label="Info about Sales lost">
                      <FontAwesomeIcon icon={faCircleInfo} />
                    </InfoIconButton>
                  </Tooltip>
                </StatLabel>
                <StatValue>(US$0.00)</StatValue>
                <StatHelp>↓ 23.36%</StatHelp>
              </StatCard>
            </StatsRow>
          ),
        },
      ]}
    />
  </ContentCard>
);

export default React.memo(OrdersWithIssuesSection);
